import {
  EditStructureBreakItem,
  EditStructureButton,
  EditStructureHeader,
  EditStructureHeaderButtonWrapper,
  EditStructureItem,
  EditStructureItemCheckBox,
  EditStructureTableBody,
  EditStructureTableHeader,
  EditStructureTableHeaderButtonWrapper,
  EditStructureTableItem,
  EditStructureTableItemWrapper,
  EditStructureTableWrapper,
  EditStructureTimeItem,
  EditStructureWrapper,
} from "./style";
import { useTournamentContext } from "../../../../hook/context";

const EditTournamentStructure = () => {
  const {
    structures,
    handleInputChange,
    handleChangeToBreak,
    handleChangeToLevel,
    handleAddLevel,
    handleAddBreak,
    handleDelete,
    handleMoveUp,
    handleMoveDown,
    handleMoveTop,
    handleMoveBottom,
    handleStructureList,
    structureCheckList,
  } = useTournamentContext();

  const headers = [
    { header: "", name: "z" },
    { header: "LV", name: "a" },
    { header: "시간", name: "c" },
    { header: "SB", name: "d" },
    { header: "BB", name: "d" },
    { header: "ANTE", name: "d" },
    { header: "칩 제거", name: "d" },
  ];

  const headerButtons = [
    { type: "bottom", click: handleMoveBottom },
    { type: "down", click: handleMoveDown },
    { type: "top", click: handleMoveTop },
    { type: "up", click: handleMoveUp },
  ];

  return (
    <EditStructureWrapper>
      <EditStructureHeader>
        <div className="title">스트럭쳐 설정</div>
        <EditStructureHeaderButtonWrapper>
          <div className="button purple" onClick={() => handleAddLevel()}>
            LEVEL 추가
          </div>
          <div className="button" onClick={() => handleAddBreak()}>
            BREAK 추가
          </div>
        </EditStructureHeaderButtonWrapper>
      </EditStructureHeader>
      <EditStructureTableWrapper>
        <EditStructureTableHeader>
          {headers.map((h, i) => (
            <div key={i} className={`box ${h.name}`}>
              {h.header}
            </div>
          ))}
          <EditStructureTableHeaderButtonWrapper>
            {headerButtons.map((b, i) => (
              <div
                key={i}
                className="move"
                onClick={() => b.click(structureCheckList)}
              >
                <img src={`/image-web/tournament/${b.type}.png`} alt={b.type} />
              </div>
            ))}
          </EditStructureTableHeaderButtonWrapper>
        </EditStructureTableHeader>
        <EditStructureTableBody>
          {structures.map((item, index) => (
            <EditStructureTableItemWrapper>
              <EditStructureItemCheckBox
                checked={structureCheckList.includes(index)}
                onClick={() => handleStructureList(index)}
              >
                <img
                  src={`/image-web/tournament/structure-${
                    structureCheckList.includes(index) ? "" : "un-"
                  }selected.svg`}
                  alt="checked"
                />
              </EditStructureItemCheckBox>
              <EditStructureTableItem>
                <div className="box a">
                  {item.type === "LEVEL" ? `${item.level}` : "-"}
                </div>
                <EditStructureTimeItem>
                  <input
                    className="data"
                    type="text"
                    value={item.time ? item.time.toLocaleString() : 0}
                    onChange={(e) => handleInputChange(e, index, "time")}
                    inputMode="numeric"
                  />
                </EditStructureTimeItem>
                {item.type === "LEVEL" ? (
                  <>
                    <EditStructureItem>
                      <input
                        className="data"
                        type="text"
                        value={
                          item.smallBlind ? item.smallBlind.toLocaleString() : 0
                        }
                        onChange={(e) =>
                          handleInputChange(e, index, "smallBlind")
                        }
                        inputMode="numeric"
                      />
                    </EditStructureItem>
                    <EditStructureItem>
                      <input
                        className="data"
                        type="text"
                        value={
                          item.bigBlind ? item.bigBlind.toLocaleString() : 0
                        }
                        onChange={(e) =>
                          handleInputChange(e, index, "bigBlind")
                        }
                        inputMode="numeric"
                      />
                    </EditStructureItem>
                    <EditStructureItem>
                      <input
                        className="data"
                        type="text"
                        value={item.ante ? item.ante.toLocaleString() : 0}
                        onChange={(e) => handleInputChange(e, index, "ante")}
                        inputMode="numeric"
                      />
                    </EditStructureItem>
                  </>
                ) : (
                  <EditStructureBreakItem>
                    <span>BREAK</span>
                  </EditStructureBreakItem>
                )}
                {item.type === "BREAK" ? (
                  <EditStructureItem>
                    <input
                      className="data"
                      type="text"
                      value={item.removeChip}
                      onChange={(e) =>
                        handleInputChange(e, index, "removeChip")
                      }
                      inputMode="numeric"
                    />
                  </EditStructureItem>
                ) : (
                  <EditStructureItem />
                )}
                <EditStructureButton>
                  {item.type === "LEVEL" ? (
                    <div
                      className="button"
                      onClick={() => handleChangeToBreak(index)}
                    >
                      BREAK 전환
                    </div>
                  ) : (
                    <div
                      className="button purple"
                      onClick={() => handleChangeToLevel(index)}
                    >
                      LEVEL 전환
                    </div>
                  )}

                  <img
                    src="/image-web/tournament/editStructures/delete.svg"
                    onClick={() => handleDelete(index)}
                    alt="delete"
                  />
                </EditStructureButton>
              </EditStructureTableItem>
            </EditStructureTableItemWrapper>
          ))}
        </EditStructureTableBody>
      </EditStructureTableWrapper>
    </EditStructureWrapper>
  );
};

export default EditTournamentStructure;
